import * as tslib_1 from "tslib";
import './modal.less';
import m from 'mithril';
import { classes } from '../util/classes';
import lockScroll from '../util/lockscroll';
import { Component } from './component';
var ModalOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(ModalOverlay, _super);
    function ModalOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalOverlay.prototype.view = function () {
        return m('.modal-overlay', this.attrs, this.children);
    };
    return ModalOverlay;
}(Component));
export { ModalOverlay };
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.opened = false;
        _this.oncreate = _this.lock;
        _this.onupdate = _this.lock;
        _this.closeByKey = function (e) {
            var close = _this.attrs.close;
            if (e.keyCode !== 27)
                return;
            close();
            m.redraw();
        };
        return _this;
    }
    Modal.prototype.lock = function () {
        var _a = this.attrs, isOpen = _a.isOpen, close = _a.close;
        if (this.opened === isOpen)
            return;
        if (isOpen)
            window.addEventListener('keydown', this.closeByKey);
        else
            window.removeEventListener('keydown', this.closeByKey);
        this.opened = isOpen;
    };
    Modal.prototype.onremove = function () {
        window.removeEventListener('keydown', this.closeByKey);
    };
    Modal.prototype.view = function () {
        var _a = this.attrs, isOpen = _a.isOpen, close = _a.close, _b = _a.zIndex, zIndex = _b === void 0 ? 1000 : _b, mod = _a.mod;
        if (!isOpen)
            return null;
        return m('.modal', tslib_1.__assign({ oncreate: function (_a) {
                var dom = _a.dom;
                return setTimeout(function () {
                    lockScroll(true);
                    dom.classList.add('is-open');
                }, 25);
            }, onbeforeremove: function (_a) {
                var dom = _a.dom;
                return new Promise(function (done) {
                    ;
                    dom.addEventListener('transitionend', function () {
                        lockScroll(false);
                        done();
                    }, false, { once: true });
                    dom.classList.remove('is-open');
                });
            }, onremove: function () { return lockScroll(false); } }, classes({ mod: mod }), { style: { zIndex: zIndex } }), m('.modal-container', {
            onclick: function (e) {
                var target = e.target;
                if (target && target.classList.contains('modal-container'))
                    close();
            }
        }, m('.modal-container-content', this.children)));
    };
    return Modal;
}(Component));
export { Modal };
